// The four flow categories the "Flow progress" row tracks, in stage order.

export const FLOW_CATEGORY_TYPES = ['DISCOVERY_MARKET_INTELLIGENCE', 'BUSINESS_CASE_STRATEGY', 'GTM_GROWTH', 'PRODUCT_DEFINITION'] as const;

export const FLOW_CATEGORY_LABELS: Record<(typeof FLOW_CATEGORY_TYPES)[number], string> = {
  DISCOVERY_MARKET_INTELLIGENCE: 'Discovery & Market',
  BUSINESS_CASE_STRATEGY: 'Business Case & Strategy',
  GTM_GROWTH: 'Go-to-Market & Growth',
  PRODUCT_DEFINITION: 'Product Definition',
};

/** One flow category's progress: documents generated out of its active document types. */
export type FlowStage = { categoryType: string; name: string; done: number; total: number };
